import { useApiMutation } from '../../../../infra/api';
import { endpoints } from '../../network';
export var useCampaignActions = function () {
    var duplicateCampaign = useApiMutation({
        endpoint: endpoints.duplicateCampaignMutation,
    });
    return {
        duplicateCampaign: duplicateCampaign,
    };
};
